import React from 'react';
import { DetailInfo, U } from '../../../../assets/img/svg/details';

import { Google, Star } from '../../../../assets/img/svg/icons';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

const Depoimento: React.FC<{ logo: string, nome: string, text: string, nota: string, cargo: string }> = ({ logo, nome, text, nota, cargo }) => {
    const stars = nota && parseFloat(nota) < 5 ? parseFloat(nota) : 5;

    return (
        <div className="bg-white rounded-xl flex flex-col items-center justify-center gap-4 p-8 drop-shadow-sm relative">
            <Google className='w-4 h-4 object-contain absolute right-4 top-4' />

            <div className="flex flex-col gap-1">
                <div className="rounded-full h-12 w-12 mx-auto border border-black/20 flex items-center justify-center overflow-hidden">
                    <img src={logo} alt={nome} className='w-full h-full object-contain' />
                </div>

                <div className="flex flex-col items-center">
                    <h4 className='font-semibold text-sm'>{nome}</h4>
                    <h5 className='font-light text-xs'>{cargo}</h5>
                    <div className="flex gap-1">
                        
                        {Array.from({ length: stars }, (_, index) => (
                            <Star key={index} className='w-4 h-4 object-contain' />
                        ))}
                    </div>
                </div>
            </div>

            <div className="text-xs md:text-sm text-center">
                {text}
            </div>
        </div>
    );
};

const InfoSection: React.FC<{depoimentos: Array<{ foto: string, nota: string, nome: string, cargo: string, texto: string }>}> = ({depoimentos}) => {
    return (
        <section className='pt-8 pb-14 max-w-[1920px] mx-auto relative'>
            <U className='absolute left-1/2 md:-left-[200px] -translate-x-1/2 md:translate-x-0 top-1/2 -translate-y-1/2 -z-10 rotate-[20deg] w-[300px] md:w-[500px] h-[300px] md:h-[500px] object-contain hidden md:block' />
            <div className="absolute left-1/2 -translate-x-1/2 -z-20 top-20 h-[calc(100%+200px)] w-dvw">
                <DetailInfo className='object-cover h-full w-full scale-150 -translate-y-44' />
            </div>

            <h3 className="text-2xl text-center font-semibold">
                Veja o depoimento <br />
                dos <span className='text-main-pink'>colégios parceiros</span>
            </h3>

            <Swiper
                className='relative mt-12'
                slidesPerView={4}
                centeredSlides
                spaceBetween={20}
                breakpoints={{
                    200: { slidesPerView: 2 },
                    991: { slidesPerView: 3 },
                }}
            >
                {depoimentos.map((depoimento, index) => (
                    <SwiperSlide key={index} className='max-w-72'>
                        <Depoimento  logo={depoimento.foto} nome={depoimento.nome} text={depoimento.texto} nota={depoimento.nota} cargo={depoimento.cargo} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default InfoSection;